import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/store";
import {getGame} from "../../app/slices/game";
import {useParams} from "react-router-dom";
import GameSession from "./GameSession";
import {startGame} from "../../app/slices/game";
import GameStart from "./GameStart";
import GameTopBar from "./GameTopBar";
import toast from "react-hot-toast";
import {translations} from "../../translations";
import GameError from "./GameError";
import GamePreLoader from "./GamePreLoader";

export const TRANSITION_DURATION = 400; // ms

const Game = () => {
    const dispatch = useAppDispatch();
    const {loaded, error, data, gameStarted, language, gameTheme} = useAppSelector((state) => state.game);
    const {session_data} = useAppSelector((state) => state.gameSession);
    const {slug} = useParams();

    const [backgroundImage, setBackgroundImage] = useState<string | null>(null);
    const [logo, setLogo] = useState<string | null>(null);
    const [isThemeLoaded, setIsThemeLoaded] = useState(false);
    const LANG = translations[language];

    // Handle game data loading
    useEffect(() => {
        if (!loaded) {
            dispatch(getGame(slug));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaded, slug]);

    // Set document title when data is loaded
    useEffect(() => {
        if (data?.name) {
            document.title = 'Scope - ' + data.name;
        }
    }, [data?.name]);

    useEffect(() => {
        if (gameTheme) {
            // Handle loading of background image
            if (gameTheme.background_image) {
                const bgImage = new Image();
                bgImage.src = gameTheme.background_image;
                bgImage.onload = () => {
                    setBackgroundImage(gameTheme.background_image);
                };
            }

            // Handle loading of logo
            if (gameTheme.logo) {
                const logoImage = new Image();
                logoImage.src = gameTheme.logo;
                logoImage.onload = () => {
                    setLogo(gameTheme.logo);
                };
            }

            // Handle setting CSS variables for colors
            if (gameTheme.colors) {
                const root = document.documentElement;
                const colors = gameTheme.colors;
                if (colors) {
                    Object.entries(colors).forEach(([key, value]) => {
                        const cssVar = `--${key.replace(/_/g, '-')}`;
                        root.style.setProperty(cssVar, value as string);
                    });
                }
            }
        }
    }, [gameTheme]);

    // Start game handler with form validation
    const handleStartGame = () => {
        const formFields = data?.form;
        if (formFields) {
            const allFieldsFilled = formFields.every((field) => !field.required || (field.required && field.value !== ''));
            if (!allFieldsFilled) {
                toast.error(LANG.fill_all_fields, {position: 'top-right'});
            } else {
                dispatch(startGame());
            }
        }
    };

    let elem;

    if (error) {
        elem = <GameError error={error}/>;
    } else if (loaded && data) {
        if (gameStarted) {
            elem = <GameSession game_id={data.id} lang={language}/>;
        } else {
            elem = <GameStart handleStart={handleStartGame} gameData={data} slug={slug} lang={language}/>;
        }
    }

    const gameThemeContainerClass = !gameStarted || session_data?.end ? 'game-theme-container show-top-bar' : 'game-theme-container';
    const backgroundStyle = backgroundImage ? {backgroundImage: `url(${backgroundImage})`} : undefined;

    setTimeout(() => {
        setIsThemeLoaded(true);
    }, 700);

    return (
        <>
            <div className="game-bg" style={backgroundStyle}></div>
            <div className={gameThemeContainerClass}>
                <GameTopBar logo={logo}/>
                <div className="game-card-container">
                    {elem}
                </div>
            </div>
            <GamePreLoader isThemeLoaded={isThemeLoaded}/>
        </>
    );
}

export default Game;